import Note from '@models/Note';
import Occasion from '@support/Occasion';
import React, { useState } from 'react';
import styles from './Note.module.scss';

export function NoteDateDisplay({ date }: { date: Occasion }) {
  const dateDisplayFormat = date.isThisYear ? 'MMM dd' : 'MMM dd yyyy';

  return (
    <>
      <span className="information-item">{date.format(dateDisplayFormat)}</span>
      <span className="information-item">{date.format('hh:mm aa')}</span>
    </>
  );
}

export default function NoteDetails({ note }: { note: Note }) {
  const [type, setType] = useState(null);
  function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();

    setType(type === 'created' ? 'updated' : 'created');
  }

  let date = note.updated;

  if (type) {
    date = note[type];
  }

  return (
    <div className={`information ${styles.noteDate}`} onClick={handleClick}>
      {!type ? null : <span>{type}&nbsp;</span>}
      <NoteDateDisplay date={date} />
    </div>
  );
}
